var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPartnerServices = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6874_13336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6962 9.86604L16.6962 8.13399L20.1604 6.13399L21.1604 7.86604L17.6962 9.86604ZM22.2355 15.3282L18.2642 14.8498L18.5034 12.8641L22.4747 13.3426L22.2355 15.3282ZM14.5034 5.93591L12.6642 5.15027L14.2355 1.47181L16.0747 2.25745L14.5034 5.93591ZM9.43792 21.5622L7.43792 18.0981L6.57189 18.5981C6.09558 18.8731 5.58991 18.9389 5.05488 18.7955C4.51986 18.6522 4.11484 18.3424 3.83984 17.866L2.83984 16.134C2.56484 15.6577 2.49902 15.152 2.64238 14.617C2.78574 14.0819 3.09558 13.6769 3.57189 13.4019L7.036 11.4019L9.86612 6.30386L15.8661 16.6962L10.036 16.5981L9.16997 17.0981L11.17 20.5622L9.43792 21.5622ZM12.3591 14.6218L9.90907 10.3782L8.51231 12.859L4.57189 15.134L5.57189 16.866L9.51231 14.591L12.3591 14.6218ZM15.4071 13.9012L12.0571 8.09883C12.6469 8.22024 13.2045 8.46117 13.7302 8.82164C14.2559 9.1821 14.6895 9.65823 15.0312 10.25C15.3729 10.8418 15.5684 11.4554 15.6177 12.0909C15.667 12.7263 15.5969 13.3298 15.4071 13.9012Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6874_13336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPartnerServices, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/PartnerServices.13730cbd.svg";
export { ForwardRef as ReactComponent };